module.exports = require("findup-sync");


//////////////////
// WEBPACK FOOTER
// external "findup-sync"
// module id = 51
// module chunks = 0